import { useEffect } from 'react'

import { useSearchForm } from '@/features/search/hooks/use-search-form'
import { HeaderSearchForm } from '@/features/search/ui/header-search-form/header-search-form'

import { useHeaderSearch } from '@/entities/header-search'

import { Icon } from '@/shared/ui/icon'

import { HeaderSearchContent } from '../header-search-content/header-search-content'

import cl from './style.module.scss'

interface HeaderSearchModalProps {
	onClose: () => void
}

export const HeaderSearchModal = (props: HeaderSearchModalProps) => {
	const { onClose } = props

	const { value, onChange, onSubmit, reset, dValue } = useSearchForm()
	const { haveData } = useHeaderSearch(dValue)
	useEffect(() => {
		if (document) {
			document.body.style.overflow = 'hidden'
		}
		return () => {
			document.body.style.overflow = 'unset'
		}
	}, [])

	return (
		<div className={cl.root} onMouseLeave={onClose}>
			<button onClick={onClose} className={cl.close}>
				<Icon name={'Close'} />
			</button>
			<div className={cl.container}>
				<div className={cl.search}>
					<HeaderSearchForm onChange={onChange} value={value} onReset={reset} onSubmit={onSubmit} />
				</div>
				{haveData && <HeaderSearchContent value={dValue} />}
			</div>
		</div>
	)
}
